import { Typography } from '@mui/material';

const AppFormSectionSubtitle = ({ children }: { children: React.ReactElement | string }) => (
  <Typography variant="body2" fontWeight={600}>
    {children}
  </Typography>
);

export default AppFormSectionSubtitle;
